import axios from 'axios';

const api = axios.create({ baseURL: '/api', withCredentials: true });

api.interceptors.request.use((config) => {
  if (config.url?.startsWith('/cpanel/')) {
    const token = localStorage.getItem('hse_cpanel_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      if (err.config?.url?.startsWith('/cpanel/')) {
        localStorage.removeItem('hse_cpanel_token');
        if (window.location.pathname === '/cpanel') window.location.href = '/cpanel/login';
      } else {
        localStorage.removeItem('hse_admin');
        if (window.location.pathname.startsWith('/admin')) window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
